import React from 'react';
import { InputNumber, Select, Text, InputSizes, SelectSizes } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import RulesPanel from '../../../../common/rulesPanel/RulesPanel';
import CapRulesTabs from './CapRulesTabs';
import AdvanceCapTenureRuleRow from './AdvanceCapTenureRuleRow';
import { ADVANCE_TIMEFRAME_OPTIONS } from '../limitsForm.constants';
import styles from '../styles/limitsForm.module.scss';

function AdvanceCapCard({
    value,
    timeframe,
    enabled,
    onChange,
    onChangeTimeframe,
    onToggleEnabled,
    tenureRules = [],
    onAddTenureRule,
    onRemoveTenureRule,
    onUpdateTenureRule,
    capRuleTab,
    onChangeCapRuleTab,
    productTypes,
    geography
}) {
    return (
        <ConfigurationCard
            title="Advance Cap"
            description="The maximum number of advances a user can make in your selected timeframe"
            togglePosition="leading"
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    size={InputSizes.SMALL}
                    value={value}
                    onChange={onChange}
                    min={0}
                    max={999}
                    step={1}
                    precision={0}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.countField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>Advances per</Text>
                <Select
                    size={SelectSizes.SMALL}
                    value={timeframe}
                    options={ADVANCE_TIMEFRAME_OPTIONS}
                    onChange={onChangeTimeframe}
                    className={`${styles.select} ${styles.selectSm}`}
                />
            </div>

            <div className={styles.tenureSection}>
                <Text as="span" size="s" className={styles.panelBlockTitle}>
                    Adjustments
                </Text>
                <CapRulesTabs
                    activeKey={capRuleTab}
                    onChange={onChangeCapRuleTab}
                    tenurePanel={(
                        <RulesPanel onAdd={onAddTenureRule} addLabel="Add tenure rule">
                            {tenureRules.map((rule) => (
                                <AdvanceCapTenureRuleRow
                                    key={rule.id}
                                    rule={rule}
                                    onUpdate={onUpdateTenureRule}
                                    onRemove={onRemoveTenureRule}
                                />
                            ))}
                        </RulesPanel>
                    )}
                    productTypes={productTypes}
                    geography={geography}
                    valueLabel="their advance cap will be exactly"
                    valueSuffixLabel="advances"
                    inputProps={{ min: 0, max: 999, step: 1, precision: 0 }}
                    inputClassName={styles.countField}
                />
            </div>
        </ConfigurationCard>
    );
}

export default AdvanceCapCard;
